import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import HomeBR from '@/views/language/home-br.vue'
import HomeID from '@/views/language/home-id.vue'
import HomeIN from '@/views/language/home-in.vue'
import HomeTR from '@/views/language/home-tr.vue'
import path from 'path'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/',
		name: 'InstaSave',
		meta: {
			appname: 'InstaSave',
			title: `InstaSave – Instagram Videos & Photos Download`,
			keywords: 'Instagram video download, instasave, instagram photo downloader',
			description: `InstaSave helps you to download Instagram videos and photos online easily. Paste the link, click download, and save your favorite IG content in high quality.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/'
				}
			]
		},
		component: Home,
	},
	{
		path: '/br/',
		name: 'instasave-home-br',
		meta: {
			appname: 'InstaSave',
			title: 'InstaSave – Baixar vídeos e fotos do Instagram',
			keywords: 'baixar vídeo do Instagram, instasave, baixar fotos do Instagram',
			description: 'O InstaSave ajuda você a baixar vídeos e fotos do Instagram online com facilidade. Cole o link, clique em baixar e salve seus conteúdos favoritos do IG em alta qualidade.',
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/br/'
				}
			]
		},
		component: HomeBR,
	},
	{
		path: '/id/',
		name: 'instasave-home-id',
		meta: {
			appname: 'InstaSave',
			title: 'InstaSave – Download video & foto Instagram',
			keywords: 'download video Instagram, instasave, download foto Instagram',
			description: 'InstaSave membantu kamu download video dan foto Instagram secara online dengan mudah. Tempel link, klik download, lalu simpan konten IG favorit kamu dalam kualitas tinggi.',
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/id/'
				}
			]
		},
		component: HomeID,
	},
	{
		path: '/in/',
		name: 'instasave-home-in',
		meta: {
			appname: 'InstaSave',
			title: 'InstaSave – Instagram वीडियो और फ़ोटो डाउनलोड',
			keywords: 'Instagram वीडियो डाउनलोड, instasave, Instagram फ़ोटो डाउनलोडर',
			description: 'InstaSave की मदद से आप आसानी से Instagram के वीडियो और फ़ोटो ऑनलाइन डाउनलोड कर सकते हैं। लिंक पेस्ट करें, डाउनलोड पर क्लिक करें और अपना पसंदीदा IG कंटेंट हाई क्वालिटी में सेव करें।',
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/in/'
				}
			]
		},
		component: HomeIN,
	},
	{
		path: '/tr/',
		name: 'instasave-home-tr',
		meta: {
			appname: 'InstaSave',
			title: 'InstaSave – Instagram video ve fotoğraf indirme',
			keywords: 'Instagram video indirme, instasave, Instagram fotoğraf indirme',
			description: 'InstaSave sayesinde Instagram videolarını ve fotoğraflarını kolayca online indirebilirsiniz. Linki yapıştırın, indir’e tıklayın ve favori IG içeriklerinizi yüksek kalitede kaydedin.',
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/tr/'
				}
			]
		},
		component: HomeTR,
	},
	{
		path: '/instagram-apk-downlad/',
		name: 'instagram-download',
		meta: {
			appname: 'InstaSave',
			title: `Download Instasave App APK for Free 2026`,
			keywords: 'instasave apk, download instasve',
			description: `Download Instasave for Android new released version to save Instagram content easily. Instasave app is free for users to download and use.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/instagram-apk-downlad/'
				}
			],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/is-it-safe-to-download-instagram-videos/',
		name: 'is-it-safe-to-download-instagram-videos',
		meta: {
			appname: 'GBWhatsApp',
			title: `Is It Safe to Download Instagram Videos? A Practical Guide for Users`,
			keywords: 'risks of download Instagram Videos',
			description: `You may wonder if it's safe to download Instagram videos. Here we made an explaination. Learn the risks and try Instasave to download Instagram videos, photos, reels and others.`,
			link: [
				{
					rel: 'canonical',
					href: `https://instasaves.io/is-it-safe-to-download-instagram-videos/`,
				},
			],
		},
		component: () => import('@/views/blog-9.vue'),
	},
	{
		path: '/instasave-to-gbwhatsapp-guide/',
		name: 'instasave-to-gbwhatsapp-guide',
		meta: {
			appname: 'GBWhatsApp',
			title: `How InstaSave Complements GBWhatsApp’s Advanced Sharing Features`,
			keywords: 'share Instagram videos on GBWhatsApp',
			description: `Learn how InstaSave and GBWhatsApp work together to download Instagram videos and share them in original quality without compression. Complete save-and-share workflow guide.`,
			link: [
				{
					rel: 'canonical',
					href: `https://instasaves.io/instasave-to-gbwhatsapp-guide/`,
				},
			],
		},
		component: () => import('@/views/blog-8.vue'),
	},
	{
		path: '/snapinsta-vs-instasave-instagram-downloader/',
		name: 'snapinsta-vs-instasave-instagram-downloader',
		meta: {
			appname: 'GBWhatsApp',
			title: `SnapInsta vs InstaSave: Which Instagram Downloader Is Better`,
			keywords: 'SnapInsta vs InstaSave',
			description: `SnapInsta and InstaSave Instagram downloaders reviewed for speed, media support, privacy, and usability to determine the best tool for content saving.`,
			link: [
				{
					rel: 'canonical',
					href: `https://instasaves.io/snapinsta-vs-instasave-instagram-downloader/`,
				},
			],
		},
		component: () => import('@/views/blog-7.vue'),
	},
	// {
	// 	path: '/blog/',
	// 	name: 'en-blogs',
	// 	meta: {
	// 		appname: 'GBWhatsApp',
	// 		title: `How to Change Fonts on GBWhatsApp (2026 Guide)`,
	// 		keywords: 'How to Change Fonts on GBWhatsApp (2026 Guide)',
	// 		description: `We write some detailed tips and tricks about using GBWhatsApp. Read any post you're interested in. `,
	// 		link: [
	// 			{
	// 				rel: 'canonical',
	// 				href: 'https://instasaves.io/blog/'
	// 			}
	// 		]
	// 	},
	// 	component: () => import('@/views/blogs.vue'),
	// },
	// {
	// 	path: '/how-change-fonts-on-gbwhatsapp',
	// 	name: 'en-blog1',
	// 	meta: {
	// 		appname: 'GBWhatsApp',
	// 		title: `How to Change Fonts on GBWhatsApp (2026 Guide)`,
	// 		keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
	// 		description: `Learn how to change fonts on GBWhatsApp in a few simple steps. Customize your chat style with unique font styles and sizes for a fresh WhatsApp look.`,
	// 		link: [
	// 			{
	// 				rel: 'canonical',
	// 				href: 'https://instasaves.io/how-change-fonts-on-gbwhatsapp/'
	// 			}
	// 		]
	// 	},
	// 	component: () => import('@/views/blog1.vue'),
	// },
	{
		path: '/video-downloader/',
		name: 'video-downloader',
		meta: {
			appname: 'InstaSave',
			title: `Instagram Video Download Online 2026`,
			keywords: 'instagram video download, download instagram video, download video from instagram, download instagram video online, instagram video download mp4, instagram video download HD',
			description: `Easily download Instagram videos online in 2026 with InstaSave. Save videos in HD without a watermark now.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/video-downloader/'
				}
			]
		},
		component: () => import('@/views/video-downloader.vue'),
	},
	{
		path: '/photo-downloader/',
		name: 'photo-downloader',
		meta: {
			appname: 'InstaSave',
			title: `Download Instagram Photos`,
			keywords: 'download instagram photos, instagram photo downloader, instagram photo download hd, instagram photo downloader 4k',
			description: `Download Instagram photos in HD with our free online Instagram Photo Downloader. Save high-quality photos and carousel to gallery.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/photo-downloader/'
				}
			]
		},
		component: () => import('@/views/photo-downloader.vue'),
	},
	{
		path: '/post-downloader/',
		name: 'post-downloader',
		meta: {
			appname: 'InstaSave',
			title: `Instasave – Instagram Post Download Made Easy`,
			keywords: 'Instagram Post Download, Instagram Post Download HD',
			description: `Download any Instagram post in seconds with InstaSave. Fast, high-quality, and hassle-free Instagram post and video downloads for everyone.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/post-downloader/'
				}
			],
			breadcrumb: [
				{ text: 'home', to:'https://instasaves.io/' },
				{
					text: 'Instagram Post Downloader',
				},
			],
		},
		component: () => import('@/views/post-downloader.vue'),
	},
	{
		path: '/story-downloader/',
		name: 'story-downloader',
		meta: {
			appname: 'InstaSave',
			title: `Instagram Story Downloader - Stories Saver`,
			keywords: 'instagram story downloader, instagram story saver, download instagram stories, save instagram stories',
			description: `Easily download your Instagram stories with Story Saver – no sign-up required. Our Instagram Story Downloader lets you save stories in just one click.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/story-downloader/'
				}
			]
		},
		component: () => import('@/views/story-downloader.vue'),
	},
	{
		path: '/reels-downloader/',
		name: 'reels-downloader',
		meta: {
			appname: 'InstaSave',
			title: `Instagram Reels Downloader`,
			keywords: 'instagram reels downloader, download instagram reels, instagram reels download, reels downloader',
			description: `Instagram Reels videos Downloader in high quality—Full HD, 1080p, 2K, and 4K, using either our online tool or the InstaSave app for a faster, one-click method to Download Instagram Reels.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/reels-downloader/'
				}
			]
		},
		component: () => import('@/views/reels-downloader.vue'),
	},
	{
		path: '/privacy/',
		name: 'instasave-privacy',
		meta: {
			appname: 'InstaSave',
			title: `Privacy Policy - Instasave`,
			keywords: '',
			description: `Read the Instasave Privacy Policy to understand how we handle user data, protect your privacy, and ensure a safe experience when using our Instagram download tools.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/privacy/'
				}
			]
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/terms/',
		name: 'instasave-terms',
		meta: {
			appname: 'InstaSave',
			title: `Terms of Service - InstaSave`,
			keywords: 'InstaSave terms of service',
			description: `Read the InstaSave Terms of Service covering permitted use, liability, third-party content, and our relationship with Instagram and Meta Platforms.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/terms/'
				}
			]
		},
		component: () => import('@/views/terms.vue'),
	},
	{
		path: '/dmca/',
		name: 'instasave-dmca',
		meta: {
			appname: 'InstaSave',
			title: `DMCA & Copyright Policy - InstaSave`,
			keywords: 'InstaSave DMCA copyright policy',
			description: `Read the InstaSave DMCA and Copyright Policy, including how to request a URL blacklist for public Instagram content.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/dmca/'
				}
			]
		},
		component: () => import('@/views/dmca.vue'),
	},
	{
		path: '/contact/',
		name: 'instasave-contact',
		meta: {
			appname: 'InstaSave',
			title: `Contact Us - InstaSave`,
			keywords: 'contact InstaSave',
			description: `Contact InstaSave for questions, bug reports, feature requests, or legal inquiries. Email support@instasaves.io.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/contact/'
				}
			]
		},
		component: () => import('@/views/contact.vue'),
	},
	{
		path: '/downloader-tips/',
		name: 'downloader-tips',
		meta: {
			appname: 'InstaSave',
			title: `Instagram Downloader Tips & News`,
			keywords: 'Instagram Downloader Tips',
			description: `Stay updated with the latest Instagram Downloader tips, tricks, and news in 2026. Learn safe download methods, new features, and updates to save Instagram photos, videos, reels, and stories easily.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/downloader-tips/'
				}
			],
			breadcrumb: [
				{ text: 'home', to:'https://instasaves.io/' },
				// { text: 'Download', to:'https://instasaves.io/downloader-tips/' },
				{
					text: 'Tips',
				},
			],
		},
		component: () => import('@/views/downloader-tips.vue'),
	},
	{
		path: '/blog/',
		name: 'blog',
		props: {
			pageTitle: 'Blog',
			blogOnly: true,
		},
		meta: {
			appname: 'InstaSave',
			title: `Instagram Blog - Tips & Guides`,
			keywords: 'Instagram blog, Instagram download guides, Instagram video tips',
			description: `Read the latest InstaSave guides for downloading Instagram videos, Reels, photos, and more with better quality and fewer errors.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/blog/'
				}
			],
			breadcrumb: [
				{ text: 'home', to:'https://instasaves.io/' },
				{
					text: 'Blog',
				},
			],
		},
		component: () => import('@/views/downloader-tips.vue'),
	},
	{
		path: '/why-instagram-video-downloader-low-quality-causes/',
		name: 'tip-1',
		meta: {
			appname: 'InstaSave',
			title: `Why Your Instagram Video Downloads Are Low Quality – Causes & Solutions`,
			keywords: 'low-quality Instagram videos',
			description: `Discover why Instagram video downloads often appear low quality and how to fix it. Learn tips for high-definition downloads using reliable tools like InstaSave for fast, clear, and smooth video saving.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/why-instagram-video-downloader-low-quality-causes/'
				}
			],
			breadcrumb: [
				{ text: 'home', to:'https://instasaves.io/' },
				{ text: 'Tips', to:'https://instasaves.io/downloader-tips/' },
				{
					text: 'Why Your Instagram Video Downloads Are Low Quality – Causes & Solutions',
				},
			],
		},
		component: () => import('@/views/tip-1.vue'),
	},
	{
		path: '/save-instagram-stories-before-they-disappear/',
		name: 'blog-2',
		meta: {
			appname: 'InstaSave',
			title: `Permanently Save Instagram Stories Before They Disappear`,
			keywords: 'download instasave story',
			description: `Save and download Instagram Stories easily with InstaSave. Keep personal memories, creative content, and professional resources safe and accessible anytime.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/save-instagram-stories-before-they-disappear/'
				}
			],
			breadcrumb: [
				{ text: 'home', to:'https://instasaves.io/' },
				{ text: 'Blog', to:'https://instasaves.io/blog/' },
				{
					text: 'Permanently Save Instagram Stories Before They Disappear',
				},
			],
		},
		component: () => import('@/views/blog-2.vue'),
	},
	{
		path: '/instasave-fix-guide/',
		name: 'blog-3',
		meta: {
			appname: 'InstaSave',
			title: `How to Fix InstaSave When It's Not Working Properly？`,
			keywords: 'instasave fix',
			description: `InstaSave stopped saving videos or photos? Here's how to get it back on track and continue downloading Instagram reels, stories, and posts with ease.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/instasave-fix-guide/'
				}
			],
			breadcrumb: [
				{ text: 'home', to:'https://instasaves.io/' },
				{ text: 'Blog', to:'https://instasaves.io/blog/' },
				{
					text: 'How to Fix InstaSave When It\'s Not Working Properly？',
				},
			],
		},
		component: () => import('@/views/blog-3.vue'),
	},
	{
		path: '/instasave-vs-fastsave/',
		name: 'blog-4',
		meta: {
			appname: 'InstaSave',
			title: `InstaSave vs FastSave: Which Instagram Downloader is Better?`,
			keywords: 'Instasave vs FastSave',
			description: `Compare Instasave and FastSave for Instagram downloads. Discover features, pros, cons, and find the best tool to save photos, reels, and stories offline.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/instasave-vs-fastsave/'
				}
			],
			breadcrumb: [
				{ text: 'home', to:'https://instasaves.io/' },
				{ text: 'Blog', to:'https://instasaves.io/blog/' },
				{
					text: 'InstaSave vs FastSave: Which Instagram Downloader is Better?',
				},
			],
		},
		component: () => import('@/views/blog-4.vue'),
	},
	{
		path: '/download-instagram-private-video/',
		name: 'blog-5',
		meta: {
			appname: 'InstaSave',
			title: `Is It Possible to Download an Instagram Private Video`,
			keywords: 'download an Instagram private video',
			description: `Explore the possibilities and limitations of downloading Instagram private videos. Learn about technical methods.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/download-instagram-private-video/'
				}
			],
			breadcrumb: [
				{ text: 'home', to:'https://instasaves.io/' },
				{ text: 'Blog', to:'https://instasaves.io/blog/' },
				{
					text: 'Is It Possible to Download an Instagram Private Video',
				},
			],
		},
		component: () => import('@/views/blog-5.vue'),
	},
	{
		path: '/instagram-private-account-viewer/',
		name: 'instagram-private-account-viewer',
		meta: {
			appname: 'GBWhatsApp',
			title: `What Is an Instagram Private Account Viewer?`,
			keywords: 'instagram private account viewer',
			description: `Understanding Instagram private account viewers and InstaSave functionality. Privacy implications, technical limitations, and alternative viewing methods explained.`,
			link: [
				{
					rel: 'canonical',
					href: `https://instasaves.io/instagram-private-account-viewer/`,
				},
			],
			breadcrumb: [
				{ text: 'home', to:'https://instasaves.io/' },
				{ text: 'Blog', to:'https://instasaves.io/blog/' },
				{
					text: 'What Is an Instagram Private Account Viewer?',
				},
			],
		},
		component: () => import('@/views/blog-6.vue'),
	},
	{
		path: '/instagram-downloaded-video-blurry/',
		name: 'instagram-downloaded-video-blurry',
		meta: {
			appname: 'InstaSave',
			title: `Why Is My Instagram Downloaded Video Blurry? Fixes That Work`,
			keywords: 'Instagram downloaded video blurry, Instagram video quality',
			description: `Downloaded an Instagram video and it looks blurry? Find out why quality drops and what you can actually do to get the clearest version.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/instagram-downloaded-video-blurry/'
				}
			],
			breadcrumb: [
				{ text: 'home', to: 'https://instasaves.io/' },
				{ text: 'Blog', to: 'https://instasaves.io/downloader-tips/' },
				{ text: 'Why Is My Instagram Downloaded Video Blurry? Fixes That Work' },
			],
		},
		component: () => import('@/views/instagram-downloaded-video-blurry.vue'),
	},
	{
		path: '/instagram-video-vs-reels-download/',
		name: 'instagram-video-vs-reels-download',
		meta: {
			appname: 'InstaSave',
			title: `Instagram Video vs Reels Download: What’s the Difference?`,
			keywords: 'Instagram video vs Reels download',
			description: `Not sure whether you're downloading an Instagram Reel or a regular video? Learn the difference, which links work, and what changes when you save each type.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/instagram-video-vs-reels-download/'
				}
			],
			breadcrumb: [
				{ text: 'home', to: 'https://instasaves.io/' },
				{ text: 'Blog', to: 'https://instasaves.io/downloader-tips/' },
				{ text: 'Instagram Video vs Reels Download: What’s the Difference?' },
			],
		},
		component: () => import('@/views/instagram-video-vs-reels-download.vue'),
	},
	{
		path: '/download-instagram-videos-without-account/',
		name: 'download-instagram-videos-without-account',
		meta: {
			appname: 'InstaSave',
			title: `How to Download Instagram Videos Without an Account`,
			keywords: 'download Instagram videos without account',
			description: `Want to download a public Instagram video without logging in? Learn what works, what doesn't, and how to save videos using your browser.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/download-instagram-videos-without-account/'
				}
			],
			breadcrumb: [
				{ text: 'home', to: 'https://instasaves.io/' },
				{ text: 'Blog', to: 'https://instasaves.io/downloader-tips/' },
				{ text: 'How to Download Instagram Videos Without an Account' },
			],
		},
		component: () => import('@/views/download-instagram-videos-without-account.vue'),
	},
	{
		path: '/download-instagram-reels-iphone-android/',
		name: 'download-instagram-reels-iphone-android',
		meta: {
			appname: 'InstaSave',
			title: `How to Download Instagram Reels on iPhone and Android`,
			keywords: 'download Instagram Reels iPhone Android',
			description: `Learn how to download Instagram Reels on iPhone and Android, where the files are saved, and what to do when the download option is missing.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://instasaves.io/download-instagram-reels-iphone-android/'
				}
			],
			breadcrumb: [
				{ text: 'home', to: 'https://instasaves.io/' },
				{ text: 'Blog', to: 'https://instasaves.io/downloader-tips/' },
				{ text: 'How to Download Instagram Reels on iPhone and Android' },
			],
		},
		component: () => import('@/views/download-instagram-reels-iphone-android.vue'),
	},
	// {
	// 	path: '/about-us',
	// 	name: 'about-us',
	// 	meta: {
	// 		appname: 'GBWhatsApp',
	// 		title: `About GB WhatsApp and Our Site`,
	// 		keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
	// 		description: `We build this site for users to download GB WhatsApp safely and for free. Learn more about us on this page.`,
	// 		link: [
	// 			{
	// 				rel: 'canonical',
	// 				href: 'https://instasaves.io/about-us/'
	// 			}
	// 		],
	// 		noindex: true
	// 	},
	// 	component: () => import('@/views/about.vue'),
	// },
	// {
	// 	path: '/transfer',
	// 	name: 'transfer',
	// 	meta: {
	// 		appname: 'GBWhatsApp',
	// 		link: [
	// 			{
	// 				rel: 'canonical',
	// 				href: 'https://instasaves.io/transfer/'
	// 			}
	// 		]
	// 	},
	// 	component: () => import('@/views/transfer.vue'),
	// },
	// {
	// 	path: '/disclaimer',
	// 	name: 'disclaimer',
	// 	meta: {
	// 		appname: 'GBWhatsApp',
	// 		title: `Disclaimer – GB WhatsApp Info Site`,
	// 		keywords: 'gbwhatsapp, gb whatsapp, gbwhatsapp download, gb whatsapp download',
	// 		description: `Read this clear and detailed GB WhatsApp disclaimer content. Please be noted that we're not the developer. You use by your own risks.`,
	// 		link: [
	// 			{
	// 				rel: 'canonical',
	// 				href: 'https://instasaves.io/disclaimer/'
	// 			}
	// 		],
	// 		noindex: true
	// 	},
	// 	component: () => import('@/views/disclaimer.vue'),
	// },

]

// export const constRoutesM = [
// 	{
// 		path: '/',
// 		name: 'Home',
// 		meta: {
// 			appname: 'GBWhatsApp',
// 			topLogo: require('@/assets/gb/GB_new_icon_small@2x.png'),
// 			footLogo: require('@/assets/gb/icon_GB_new@2x.png'),
// 			showBreadcrumb: true,
// 			showTelegram: true,
// 		},
// 		// component: HomeM,
// 	},
// 	{
// 		path: '/download',
// 		name: 'download',
// 		meta: {
// 			appname: 'GBWhatsApp',
// 			topLogo: require('@/assets/gb/GB_new_icon_small@2x.png'),
// 			footLogo: require('@/assets/gb/icon_GB_new@2x.png'),
// 			showBreadcrumb: false,
// 		},
// 		component: () => import('@/components/download.vue'),
// 	},
// ]

let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
